import { useEffect, useState, useContext } from "react";
import { API } from "../../conf";
import { Context } from "../../App";
import moment from "moment";
import { Box, Typography, Backdrop, CircularProgress, TableContainer, Table, TableHead, TableBody, TableRow, TableCell, IconButton, Dialog } from "@mui/material";
import { InsertDriveFileOutlined } from "@mui/icons-material";
import pdfMake from "pdfmake/build/pdfmake";
import recu from "../../asset/pdfmaker";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake?.vfs || pdfFonts.vfs;

export default function DonHistory(props) {
    const { updateConnect } = useContext(Context)
    const [logs, setLogs] = useState([])
    const [load, setLoad] = useState(true)
    const [open, setOpen] = useState(false)
    const [pdf, setPdf] = useState()
    
    function get_recu(don) {
        setLoad(true)
        const pdfDocGenerator = pdfMake.createPdf(recu(don, props.don.recu_num !== don.recu_num, props.don.recu_num));
        pdfDocGenerator.getBlob((blob) => {
            setPdf(URL.createObjectURL(blob))
        });
        setOpen(true);  setLoad(false)
        
    }

    function pre_stringify(obj, nested_level=1) {
        if (typeof obj !== 'object') {
            return obj
        }
        Object.keys(obj).forEach(key=>{
            if(typeof obj[key] === 'undefined' || obj[key].length<=0){
                delete obj[key]
            }
            else if (obj[key] instanceof Date || /^date$|^.*_date|date_.*$/g.test(key)) {
                obj[key] = moment.utc(obj[key]).format('DD/MM/YYYY')
            }
            else if(typeof obj[key]==='number'&& ['solde', 'montant', 'especes', 'dime', 'offrande_globale', 'percent'].includes(key)){
                obj[key]=obj[key].toFixed(2)+(key==='percent'? '%' : '€')
            }
            else if (obj[key] instanceof Array) {
                obj[key] = (obj[key]).reduce((all, current)=>{
                    if (current instanceof Object) {
                        const haveNested = Boolean(Object.keys(current).find(k=>typeof current[k] === 'object'));
                        return all+';;;'+';tab;'.repeat(nested_level)+JSON.stringify(pre_stringify(current, nested_level+1)).replace(/["{}]/g, '')
                        .replaceAll(',', haveNested ? ';;;'+';tab;'.repeat(nested_level) : ' - ')
                    } else {
                        return all+';;;'+';tab;'.repeat(nested_level)+JSON.stringify(current).replace(/["{}]/g, '')
                    }
                }, '')
            }else if (obj[key] instanceof Object) {
                obj[key] = Object.keys(obj[key]).find(k=>typeof obj[key][k]==='object') ? 
                ';;;'+';tab;'.repeat(nested_level)+JSON.stringify(pre_stringify(obj[key], nested_level+1)).replace(/["{}]/g, '').replaceAll(',', ';;;'+';tab;'.repeat(nested_level)) :
                JSON.stringify(pre_stringify(obj[key], nested_level+1)).replace(/["{}]/g, '').replaceAll(',', ' - ')
            }
        })

        return obj
    }

    useEffect(()=>{
        fetch(API.concat(`/dons/${props.don.num}/history`), {
            method:'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response => {
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json()
                    function prepare(d){
                        delete d.is_verse; delete d.eglise; delete d.is_cloture; delete d._id; 
                        return JSON.stringify(pre_stringify(d)).replace(/is_|["{}]/g, '').replaceAll(/;;;|,/g, '\n').replaceAll(';tab;', '\t').replaceAll(/_/g, ' ').replaceAll(':', ': ').replaceAll("false", "non").replaceAll('true', 'oui')
                    }
                    const sorted = json.map(log => {
                        log.user = log.who.nom+' '+log.who.prenom1+(Boolean(log.who.prenom2)?' '+log.who.prenom2:'')
                        log.details =  prepare(JSON.parse(log.what))
                        log.what = JSON.parse(log.what)
                        return log
                    })
                    .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
                    setLogs(sorted)
                }
                setLoad(false)
            }
        })
    }, [props, updateConnect])

    return(
        <Box style={{display:'flex', flexDirection:'column', margin:'10px'}} sx={{overflow:'auto'}} >
            <Typography sx={{textAlign:'center', marginY:'20px', fontSize:26}}>Historique</Typography>
            {logs && !load && <TableContainer sx={{maxHeight:'100%'}}>
                <Table
                aria-labelledby="tableTitle">
                    <TableHead>
                        <TableRow>
                            <TableCell align='center' sx={{fontWeight:'bold'}} > Date </TableCell>
                            <TableCell align='center' sx={{fontWeight:'bold'}} > Utilisateur </TableCell>
                            <TableCell align='center' sx={{fontWeight:'bold'}} > Action </TableCell>
                            <TableCell align='center' sx={{fontWeight:'bold'}} > N° reçu </TableCell>
                            <TableCell ></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                    {logs.map((row, index) =>
                        <TableRow key={index} >
                            <TableCell align='center' sx={{minWidth:'70px'}}> {new Date(row.when).toLocaleDateString('fr-FR', {weekday: 'short',year: 'numeric', month: 'short',day: 'numeric'})} </TableCell>
                            <TableCell sx={{minWidth:'120px'}} style={{textTransform:'capitalize'}} align="center">{row.who.nom+' '+row.who.prenom1+' '+row.who.prenom2}</TableCell>
                            <TableCell sx={{minWidth:'100px'}} align="center">{row.action}</TableCell>
                            {/* <TableCell style={{whiteSpace:'pre-wrap'}} sx={{minWidth:'400px', width:'100%'}}>{row.details}</TableCell> */}
                            <TableCell style={{whiteSpace:'pre-wrap'}} align="center" sx={{minWidth:'130px'}}>{row.what.recu_num}</TableCell>
                            <TableCell><IconButton aria-label="Edit reçu" onClick={()=>get_recu(row.what)}><InsertDriveFileOutlined fontSize="small"/></IconButton></TableCell>
                        </TableRow>
                    )}
                    </TableBody>
                </Table>
            </TableContainer>}
            <Dialog open={open} onClose={()=>setOpen(false)} maxWidth='md' fullWidth>
                {pdf && <embed src={pdf} width='100%' height='400px' type="application/pdf" />}
            </Dialog>
            <Backdrop open={load}><CircularProgress color="inherit" /></Backdrop>
        </Box>
    )
}